var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMaster = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5594 21.1331C22.4877 22.9208 19.8003 24 16.8637 24C10.3115 24 5 18.6274 5 12C5 5.37258 10.3115 0 16.8637 0C19.8003 0 22.4877 1.07922 24.5594 2.86694C26.6311 1.07922 29.3185 0 32.2551 0C38.8072 0 44.1187 5.37258 44.1187 12C44.1187 18.6274 38.8072 24 32.2551 24C29.3185 24 26.6311 22.9208 24.5594 21.1331Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5586 21.1331C27.1092 18.932 28.7266 15.6571 28.7266 12C28.7266 8.34294 27.1092 5.06796 24.5586 2.86694C26.6303 1.07922 29.3177 0 32.2543 0C38.8064 0 44.118 5.37258 44.118 12C44.118 18.6274 38.8064 24 32.2543 24C29.3177 24 26.6303 22.9208 24.5586 21.1331Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5605 21.1331C27.1112 18.932 28.7285 15.6571 28.7285 12C28.7285 8.34294 27.1112 5.06796 24.5605 2.86694C22.0099 5.06796 20.3926 8.34294 20.3926 12C20.3926 15.6571 22.0099 18.932 24.5605 21.1331Z",
    fill: "#FF5E00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaster, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/master.b49d8806.svg";
export { ForwardRef as ReactComponent };